export default "__VITE_ASSET__D7gV1Fyc__"